import axios from 'axios';

export const logPhonesApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/log-phones`,
    headers: {
        'Content-Type': 'application/json'
    }
})